export interface ContactModel {
  name: string
  lineId: string
}

const contactConstant: Array<ContactModel> = [
  { name: "พี่อาร์ท ( P’Art )", lineId: "LineID : artter19100" },
  { name: "พี่อาร์ม ( P’Arm )", lineId: "LineID : arm16032547" },
  { name: "พี่ออกัส ( P’August )", lineId: "LineID : august282548" }
]

export default contactConstant
